export const SUCCESS_UPDATE_CUISINES = "SUCCESS_UPDATE_CUISINES";
export const SUCCESS_PLACE_CUISINES = "SUCCESS_PLACE_CUISINES";
export const SUCCESS_CUISINES = "SUCCESS_CUISINES";
export const SELECT_CUISINE = "SELECT_CUISINE";

export const SUCCESS_MENUS = "SUCCESS_MENUS";
export const SUCCESS_MENU_ITEM = "SUCCESS_MENU_ITEM";